var _defs, _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _ellipse, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _path8, _path9, _ellipse2, _rect2, _path10, _path11, _path12, _ellipse3, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _path13, _path14, _ellipse4, _ellipse5, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _rect3, _path33, _path34, _path35, _ellipse6, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _path36, _path37, _ellipse7, _ellipse8, _path38, _path39, _ellipse9, _path40, _path41, _ellipse10, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _rect4, _path63, _path64, _ellipse11, _rect5, _path65, _path66, _ellipse12, _path67, _ellipse13, _path68, _ellipse14, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _polygon22, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _circle, _circle2, _path111, _g, _polygon23, _polygon24, _path112, _polygon25, _path113, _path114, _path115, _path116, _polygon26, _polygon27, _polygon28, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _g2, _path142, _path143, _path144, _path145, _path146, _path147, _polygon29, _polygon30, _polyline, _polyline2, _path148, _path149, _polygon31, _path150, _polygon32, _polygon33, _ellipse15, _path151, _path152, _path153, _path154, _path155, _path156, _ellipse16, _ellipse17, _path157, _ellipse18, _ellipse19, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _polygon34, _polygon35, _ellipse20, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _path196, _path197, _ellipse28, _ellipse29, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _path208, _path209, _path210, _path211;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    width: 1103.13,
    height: 834.15,
    viewBox: "0 0 1103.13 834.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ceac7335-2455-461d-90f8-41e05a42a239-70",
    x1: 394.52,
    y1: 617.07,
    x2: 394.52,
    y2: 476.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "off road") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.6,363.79C116.43,410,152.05,450,208.35,469.39c117,40.27,380.86,19.5,577.78-4.34C888,452.72,977.52,418.7,1042.56,370.79Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1132.28,146.09h-108c-5.13,0-9.34-2.7-9.34-6s4.21-6,9.34-6h18.68c-5.14,0-9.34-2.7-9.34-6s4.2-6,9.34-6h-13.34c-5.14,0-9.34-2.7-9.34-6s4.2-6,9.34-6H1086c-12.51-3.75-27.1-6.41-44-7.8C888.2,89.57,833.29,98,813.92,106.61a287,287,0,0,1-79,22.28C640,141.47,462.57,156.62,301.75,124c-79.93-16.19-139.34,11.17-174.95,56.9H1151.05c-1.34-13.3-5.34-25.57-12.69-36.31A12.65,12.65,0,0,1,1132.28,146.09Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.43,267.25a198.53,198.53,0,0,0,4.19,80.69l948.67,22.31c26.26-19.44,48.51-41.16,65.91-64.63Zm375.21,57.56H447c5.13,0,9.33,2.71,9.33,6s-4.2,6-9.33,6h-108c-5.14,0-9.34-2.7-9.34-6s4.2-6,9.34-6h18.67c-5.13,0-9.34-2.7-9.34-6s4.21-6,9.34-6H344.25c-5.13,0-9.34-2.71-9.34-6s4.21-6,9.34-6H452.3c5.14,0,9.34,2.7,9.34,6s-4.2,6-9.34,6h13.34c5.14,0,9.34,2.7,9.34,6S470.78,324.81,465.64,324.81Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1151.09,181.35,115.37,197.55a190.42,190.42,0,0,0-24.8,68.78H1132.94a201.59,201.59,0,0,0,15-43.84C1151.09,208.15,1152.33,194.27,1151.09,181.35ZM300.86,234.43H282.18c5.14,0,9.34,2.71,9.34,6s-4.2,6-9.34,6h-108c-5.14,0-9.34-2.7-9.34-6s4.2-6,9.34-6h18.68c-5.14,0-9.34-2.7-9.34-6s4.2-6,9.34-6H179.47c-5.14,0-9.34-2.71-9.34-6s4.2-6,9.34-6h108c5.13,0,9.33,2.7,9.33,6s-4.2,6-9.33,6h13.34c5.13,0,9.33,2.7,9.33,6S306,234.43,300.86,234.43Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 580.73,
    y: 263.67,
    width: 5.57,
    height: 307.05,
    fill: "#535f89"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M640,661.08a14.53,14.53,0,0,1-17.83,0c-2.49-16.43,3.83-48.72,5.32-56l.31-1.46H635a5,5,0,0,1,1.11,1.67C641,615.82,640,661.08,640,661.08Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#535f89"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M633.49,597v6.63h-3V597a8.72,8.72,0,0,1,1.46-.12A9.82,9.82,0,0,1,633.49,597Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M636.06,605.32a8.5,8.5,0,0,1-4.12,1,8.15,8.15,0,0,1-4.43-1.18l.31-1.46H635A5,5,0,0,1,636.06,605.32Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 583.51,
    cy: 568.66,
    rx: 6.01,
    ry: 3.57,
    fill: "#dce2ed"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "557.1 214.21 578.26 204.08 609.46 211.54 585.25 193.24 557.1 214.21",
    fill: "#01bf71"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "563.29 217.45 557.1 214.21 578.26 204.08 609.46 211.54 603.97 214.21 578.26 208.44 563.29 217.45",
    fill: "#01bf71"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "563.29 217.45 557.1 214.21 578.26 204.08 609.46 211.54 603.97 214.21 578.26 208.44 563.29 217.45",
    opacity: 0.1
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "562.45 215.06 579.48 262.78 587.92 262.78 603.69 212.1 578.26 206.19 562.45 215.06",
    fill: "#01bf71",
    opacity: 0.2
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "592.1 249.35 588.74 260.17 587.92 262.78 579.48 262.78 578.85 261.01 574.87 249.86 581.26 246.02 592.1 249.35",
    fill: "#01bf71"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "578.26 208.44 582.29 262.78 579.48 262.78 563.29 217.45 578.26 208.44",
    fill: "#01bf71",
    opacity: 0.2
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "585.25 193.24 578.26 204.08 557.1 214.21 585.25 193.24",
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M637.17,293.1l-.81,2.61h-8.45l-.63-1.77a7.07,7.07,0,0,1,5.42-2A8.11,8.11,0,0,1,637.17,293.1Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M633.49,296.6v4.65c-.26,0-.52,0-.79,0a9.25,9.25,0,0,1-2.22-.26V296.6Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 584.26,
    cy: 263.67,
    rx: 6.01,
    ry: 3.57,
    fill: "#dce2ed"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 799.08,
    y: 413.01,
    width: 3.68,
    height: 203,
    fill: "#535f89"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M854.69,686.91a9.6,9.6,0,0,1-11.78,0c-1.65-10.86,2.53-32.22,3.51-37,.13-.63.21-1,.21-1h4.71a3.34,3.34,0,0,1,.74,1.1C855.34,657,854.69,686.91,854.69,686.91Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#535f89"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M850.37,644.55v4.39h-2v-4.39a5,5,0,0,1,1-.08A6.69,6.69,0,0,1,850.37,644.55Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M852.08,650a5.71,5.71,0,0,1-2.73.64,5.5,5.5,0,0,1-2.93-.77c.13-.63.21-1,.21-1h4.71A3.34,3.34,0,0,1,852.08,650Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 800.92,
    cy: 614.65,
    rx: 3.97,
    ry: 2.36,
    fill: "#dce2ed"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "783.46 380.31 797.45 373.61 818.08 378.55 802.07 366.45 783.46 380.31",
    fill: "#01bf71"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "787.55 382.45 783.46 380.31 797.45 373.61 818.08 378.55 814.45 380.31 797.45 376.5 787.55 382.45",
    fill: "#01bf71"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "787.55 382.45 783.46 380.31 797.45 373.61 818.08 378.55 814.45 380.31 797.45 376.5 787.55 382.45",
    opacity: 0.1
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "786.99 380.87 798.25 412.42 803.84 412.42 814.26 378.92 797.45 375.01 786.99 380.87",
    fill: "#01bf71",
    opacity: 0.2
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "806.6 403.54 804.38 410.7 803.84 412.43 798.25 412.43 797.84 411.26 795.21 403.89 799.43 401.35 806.6 403.54",
    fill: "#01bf71"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "797.45 376.5 800.12 412.42 798.25 412.42 787.55 382.45 797.45 376.5",
    fill: "#01bf71",
    opacity: 0.2
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "802.07 366.45 797.45 373.61 783.46 380.31 802.07 366.45",
    opacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M852.81,443.63l-.54,1.72h-5.58l-.42-1.17a4.68,4.68,0,0,1,3.58-1.34A5.36,5.36,0,0,1,852.81,443.63Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M850.37,445.94V449l-.52,0a6.15,6.15,0,0,1-1.46-.17v-2.93Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 801.42,
    cy: 413.01,
    rx: 3.97,
    ry: 2.36,
    fill: "#dce2ed"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 445,
    cy: 790.15,
    rx: 445,
    ry: 44,
    fill: "#01bf71",
    opacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M495.27,720.69s-89.2-3.75-98.59-178.4,83.57-204.23,83.57-204.23,29.45-16.45,42.51-17.13,56.71,3.43,56.71,3.43l-48.12-9.28s67.71-25.77,88-27.83l-73.2,15.46s-1-40.55,16.5-53.95c0,0-15-1.12-22.91,28.09a55.8,55.8,0,0,1-33.42,37.5c-27.15,10.59-64.69,27.31-73.24,41.63,0,0-15.81,16.5-13.4-26.46s13.74-79.74,17.87-80.77c0,0,32.3-34.36,77.67-36.42,0,0-26.46-10.66-71.14,22.68,0,0-3.78-16.84,13.06-36.78s43-61.86,71.48-66.32c0,0-39.86-2.41-71.48,49.14,0,0-11.69,7.56-12.72-11.68s-7.9-43.31-7.9-43.31-9.63,44.34,10.65,64.27c0,0-38.84,50.52-37.12,107.23,0,0-12,25.77-16.49-4.47,0,0-2.59-41.65-7.76-77a104.62,104.62,0,0,1,21.94-80.71c8.59-10.69,14.57-21.07,11.25-26.52l-45,53.61S336.14,74.86,308.65,56s-30.93-23-30.93-23l44.33,51.89L266.38,65.23,322.05,91s25.78,21,40.56,78.36,16.15,93.13,16.15,93.13-79.39-62.89-94.51-60.83l51.37,38.86a122.37,122.37,0,0,1,48.29,89.33h0s-99.32-25.43-123.38-30.24l-45.36-46.4,34.37,44-70.8-1-40.55-28.87s32,26.81,28.86,28.53-49.83,3.78-49.83,3.78,118.91-.69,132,7.9,42.27,11.69,42.27,11.69l-84.2,12.71,100.36-7.21s75.95,13.74,80.07,37.46c0,0-15.47,40.36-25.77,56.36-8.56,13.3-25.78,56.36-29.21,94.17s-8.25,95.88,4.81,131.28,17.87,55.68,11.34,66.33-12.72,24.4,8.59,27.15,114.79-1.37,114.79-1.37S500.78,741.72,495.27,720.69Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#dea3a2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M445.31,701.94A44.9,44.9,0,0,0,415,698.15c-17.5,3.79-44.31,1.78-46.75,1.36",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M389.32,496.14s-4.26,67.18,3.31,80.43Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M373.6,576.57s5.46,62.92,9.24,75.22S373.6,576.57,373.6,576.57Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M368.28,421.86c-3.87,1.42-20.43,35-17.11,44.95S368.28,421.86,368.28,421.86Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M410.26,387c-1.79.81-9.5,20.16-8,25.88S410.26,387,410.26,387Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M338.56,499.81c1.92,19.51,3,32.28,1.74,47.9a184.7,184.7,0,0,0,.52,36.43",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M545.9,272.66c-2.33,2.66-3.11,6.35-3.22,9.89s.34,7.08.11,10.61c-.25,3.71-2,8.07-5.7,8.56",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M482.44,156.35A89.35,89.35,0,0,0,470,171.79a36.81,36.81,0,0,1-3.53,5c-2,2.18-4.54,3.73-6.82,5.59a32.1,32.1,0,0,0-10.87,17",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M302.78,55.93a22.21,22.21,0,0,0,4.41,5.9c1.56,1.48,3.34,2.74,4.75,4.36a34.56,34.56,0,0,1,3,4.48c3.62,5.79,8.17,10.94,12.71,16",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M386,155.35c-3,1.85-3.73,5.81-3.67,9.3s.66,7.13-.63,10.37c-.59,1.48-1.55,2.78-2.17,4.24-1.06,2.52-1.06,5.34-1,8.08.05,3.16.15,6.33.29,9.49.16,3.8.52,7.94,3.11,10.73",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M361.09,254a40.94,40.94,0,0,1,7.71,5.31,13.84,13.84,0,0,1,4.48,8c.17,1.33.08,2.69.38,4a12.62,12.62,0,0,0,2.63,4.83,66.42,66.42,0,0,0,6.51,7.21",
    transform: "translate(-48.43 -32.93)",
    fill: "none"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M383.53,343.68a46.94,46.94,0,0,0-6.22-4.32,25.84,25.84,0,0,0-6.39-2.81c-3.43-.91-7-.77-10.56-1.14s-7.22-1.35-9.62-4",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M243.79,300.26c4.18.12,8.52.27,12.24,2.18,1.9,1,3.55,2.38,5.41,3.42a16.36,16.36,0,0,0,7.89,2.05",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M301.77,317.52c-.9-.7-2.26-.16-3,.7s-1.15,2-1.92,2.8c-1.53,1.65-4,1.84-6.27,1.92",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M325.68,228.69l4,2.11A71.08,71.08,0,0,1,341.55,238",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M371.6,268c2.64-.63,4.92,2.19,5.39,4.86s-.08,5.49.67,8.1a15.11,15.11,0,0,0,4,5.93",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M416.3,272.89c2.41,7.18-2.69,15-1.2,22.43.45,2.26,1.5,4.36,2,6.61,1.39,5.9-1,12.18-4.86,16.87",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 217.24,
    y: 181.71,
    width: 6.95,
    height: 383.28,
    fill: "#535f89"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M279.22,669.61a18.12,18.12,0,0,1-22.25,0c-3.1-20.51,4.78-60.82,6.64-69.86l.39-1.83h8.9a6.59,6.59,0,0,1,1.39,2.08C280.45,613.12,279.22,669.61,279.22,669.61Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#535f89"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M271.07,589.64v8.28h-3.75v-8.29a10.86,10.86,0,0,1,1.83-.14A12,12,0,0,1,271.07,589.64Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M274.29,600a10.64,10.64,0,0,1-5.14,1.21,10.26,10.26,0,0,1-5.54-1.46l.39-1.83h8.9A6.59,6.59,0,0,1,274.29,600Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.72,
    cy: 562.42,
    rx: 7.5,
    ry: 4.45,
    fill: "#dce2ed"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "187.74 119.97 214.16 107.32 253.11 116.63 222.88 93.79 187.74 119.97",
    fill: "#01bf71"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "195.47 124.01 187.74 119.97 214.16 107.32 253.11 116.63 246.25 119.97 214.16 112.77 195.47 124.01",
    fill: "#01bf71"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "195.47 124.01 187.74 119.97 214.16 107.32 253.11 116.63 246.25 119.97 214.16 112.77 195.47 124.01",
    opacity: 0.1
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "194.42 121.03 215.68 180.59 226.22 180.59 245.9 117.34 214.16 109.96 194.42 121.03",
    fill: "#01bf71",
    opacity: 0.2
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "231.44 163.83 227.23 177.34 226.22 180.6 215.68 180.6 214.89 178.39 209.93 164.48 217.9 159.68 231.44 163.83",
    fill: "#01bf71"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "214.16 112.77 219.19 180.59 215.68 180.59 195.47 124.01 214.16 112.77",
    fill: "#01bf71",
    opacity: 0.2
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "222.88 93.79 214.16 107.32 187.74 119.97 222.88 93.79",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M275.67,210.27l-1,3.26H264.11l-.78-2.21c1.19-1.5,3.76-2.54,6.76-2.54A10.19,10.19,0,0,1,275.67,210.27Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M271.07,214.64v5.8c-.32,0-.65.05-1,.05a11.62,11.62,0,0,1-2.77-.33v-5.52Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 221.65,
    cy: 181.71,
    rx: 7.5,
    ry: 4.45,
    fill: "#dce2ed"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 914.02,
    cy: 687.72,
    rx: 16.82,
    ry: 2.84,
    fill: "#01bf71",
    opacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M951.16,707.44s9.59-.3,12.48-2.36,14.76-4.51,15.47-1.21,14.42,16.42,3.59,16.51-25.17-1.69-28.05-3.45S951.16,707.44,951.16,707.44Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#a8a8a8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M982.89,719.23c-10.83.09-25.16-1.69-28-3.45-2.19-1.34-3.07-6.14-3.36-8.35h-.32s.6,7.73,3.49,9.49,17.22,3.53,28.05,3.45c3.13,0,4.2-1.14,4.15-2.79C986.41,718.59,985.22,719.21,982.89,719.23Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.2
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1011.56,
    cy: 654.6,
    rx: 12.94,
    ry: 2.19,
    fill: "#01bf71",
    opacity: 0.1
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1051.3,677.36s7.38-.23,9.61-1.81,11.35-3.48,11.9-.94,11.1,12.64,2.76,12.7-19.36-1.29-21.58-2.65S1051.3,677.36,1051.3,677.36Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#a8a8a8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.72,686.43c-8.33.07-19.36-1.3-21.58-2.65-1.69-1-2.37-4.73-2.59-6.43h-.25s.47,5.95,2.69,7.3,13.25,2.72,21.58,2.65c2.41,0,3.24-.87,3.19-2.14C1078.43,685.94,1077.51,686.42,1075.72,686.43Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.2
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 952.84,
    cy: 792.9,
    rx: 30.89,
    ry: 5.22,
    fill: "#01bf71",
    opacity: 0.1
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M980.53,801.56s17.62-.55,22.93-4.33,27.11-8.3,28.43-2.23,26.48,30.16,6.58,30.32S992.25,822.23,987,819,980.53,801.56,980.53,801.56Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#a8a8a8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1038.83,823.21c-19.9.16-46.23-3.1-51.53-6.32-4-2.46-5.64-11.29-6.18-15.36l-.59,0S981.65,815.77,987,819s31.63,6.49,51.52,6.32c5.75,0,7.73-2.08,7.62-5.11C1045.29,822,1043.1,823.18,1038.83,823.21Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M682.52,580.23s51.23-2.16,56.62-102.46-48-117.3-48-117.3-16.91-9.45-24.41-9.84-32.57,2-32.57,2l27.63-5.33s-38.88-14.8-50.53-16l42,8.88s.59-23.29-9.48-31c0,0,8.58-.64,13.16,16.13a32,32,0,0,0,19.19,21.54c15.6,6.09,37.16,15.69,42.07,23.91,0,0,9.08,9.48,7.69-15.2s-7.89-45.8-10.26-46.39c0,0-18.55-19.73-44.61-20.92,0,0,15.2-6.11,40.86,13,0,0,2.17-9.67-7.5-21.12s-24.67-35.53-41.06-38.09c0,0,22.9-1.39,41.06,28.22,0,0,6.71,4.34,7.3-6.71s4.54-24.87,4.54-24.87,5.53,25.46-6.12,36.91c0,0,22.31,29,21.32,61.59,0,0,6.91,14.8,9.48-2.57,0,0,1.48-23.92,4.45-44.21a60.13,60.13,0,0,0-12.6-46.36c-4.93-6.13-8.37-12.1-6.46-15.23l25.86,30.79s21.71-50.33,37.5-61.19,17.77-13.22,17.77-13.22L782,215l32-11.25-32,14.81s-14.8,12-23.29,45-9.28,53.49-9.28,53.49S795,281,803.72,282.14l-29.51,22.31a70.31,70.31,0,0,0-27.74,51.31h0s57-14.61,70.87-17.37l26-26.65L823.65,337l40.66-.59,23.3-16.58S869.25,335.23,871,336.22s28.63,2.17,28.63,2.17-68.3-.39-75.8,4.54-24.28,6.71-24.28,6.71L847.93,357l-57.64-4.15s-43.62,7.9-46,21.52c0,0,8.89,23.18,14.81,32.37,4.91,7.63,14.8,32.37,16.77,54.08s4.74,55.07-2.76,75.4-10.26,32-6.51,38.1,7.3,14-4.94,15.59-65.93-.79-65.93-.79S679.35,592.31,682.52,580.23Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#dea3a2"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M711.21,569.46a25.76,25.76,0,0,1,17.39-2.17c10,2.17,25.45,1,26.85.78",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M743.37,451.26s2.44,38.59-1.9,46.19Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M752.39,497.45s-3.13,36.14-5.3,43.21S752.39,497.45,752.39,497.45Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M755.45,408.6c2.22.82,11.73,20.11,9.83,25.81S755.45,408.6,755.45,408.6Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M731.34,388.58c1,.46,5.46,11.58,4.57,14.86S731.34,388.58,731.34,388.58Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M772.52,453.37c-1.1,11.21-1.7,18.54-1,27.51a105.41,105.41,0,0,1-.3,20.92",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M653.43,322.91a9,9,0,0,1,1.86,5.68c.07,2-.2,4.06-.07,6.09s1.16,4.63,3.28,4.92",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M689.89,256.1A51.22,51.22,0,0,1,697,265a20.84,20.84,0,0,0,2,2.89,33,33,0,0,0,3.92,3.21,18.46,18.46,0,0,1,6.24,9.79",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M793.07,198.43a12.94,12.94,0,0,1-2.53,3.39c-.9.85-1.92,1.57-2.73,2.5a19.71,19.71,0,0,0-1.75,2.57,69.5,69.5,0,0,1-7.29,9.22",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M745.28,255.53c1.71,1.06,2.15,3.34,2.11,5.34s-.38,4.1.37,6c.34.85.89,1.6,1.24,2.44a11.44,11.44,0,0,1,.59,4.63c0,1.82-.09,3.64-.17,5.45-.09,2.19-.3,4.56-1.78,6.17",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M759.58,312.16a23.72,23.72,0,0,0-4.43,3,7.94,7.94,0,0,0-2.57,4.62c-.1.76-.05,1.54-.22,2.29a7.3,7.3,0,0,1-1.51,2.77,37.58,37.58,0,0,1-3.74,4.14",
    transform: "translate(-48.43 -32.93)",
    fill: "none"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M746.69,363.7a28.1,28.1,0,0,1,3.57-2.48,15.1,15.1,0,0,1,3.68-1.62A39.55,39.55,0,0,1,760,359a8.59,8.59,0,0,0,5.53-2.27",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M827,338.76c-2.4.07-4.89.15-7,1.25-1.09.56-2,1.37-3.11,2a9.33,9.33,0,0,1-4.53,1.18",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M793.65,348.67a1.35,1.35,0,0,1,1.73.4c.43.49.66,1.13,1.11,1.61.87.95,2.3,1.06,3.59,1.1",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M779.92,297.66l-2.31,1.2a40.93,40.93,0,0,0-6.8,4.15",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M753.55,320.22c-1.52-.36-2.83,1.26-3.1,2.8s0,3.15-.39,4.65a8.7,8.7,0,0,1-2.27,3.41",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M727.87,323c-1.38,4.12,1.55,8.62.69,12.88-.26,1.3-.86,2.51-1.17,3.8-.8,3.39.58,7,2.79,9.69",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M429.52,405.72c-16.42,22.14-29.94,87.27-33.73,106.9l-28.6-1.13c1.8-16.89,36.38-85.09,46-103.8C418.34,407,423.85,406.3,429.52,405.72Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 725.73,
    y: 364.93,
    width: 12.68,
    height: 17.86,
    fill: "#dce0ed"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M786.84,397.86v5.81a9.76,9.76,0,0,1-2.75.37l-9.92-.08v-6.1Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M768.81,352.36h12a14.37,14.37,0,0,1,13.31,9c3.5,8.63,6.47,22.35-1.33,36a9.88,9.88,0,0,1-8.67,5l-15.28-.13Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#dce0ed"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 720.38,
    cy: 344.37,
    rx: 12.82,
    ry: 24.93,
    fill: "#f0f0f4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 613.13,
    y: 365.14,
    width: 12.68,
    height: 15.63,
    fill: "#dce0ed"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M674.24,398.07v5a9.78,9.78,0,0,1-2.76.37l-9.92-.09v-5.25Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M656.21,352.58h12a14.34,14.34,0,0,1,13.3,9c3.51,8.63,6.48,22.35-1.32,36a9.9,9.9,0,0,1-8.68,5l-15.27-.14Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#dce0ed"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 607.78,
    cy: 344.58,
    rx: 12.82,
    ry: 24.93,
    fill: "#f0f0f4"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M659.41,361.69s-4.73.76-2.27,7a42.66,42.66,0,0,1,2.83,9.45s4.73,2.46,4.54-5.67S659.41,361.69,659.41,361.69Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#dce0ed"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.6,
    cy: 685,
    rx: 74.79,
    ry: 81.97,
    fill: "#636780"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M207.05,641.07c-39.13,2.63-70.13,38.25-70.13,81.81,0,35.11,20.14,65.06,48.45,76.73,39.14-2.63,70.14-38.25,70.14-81.81C255.51,682.69,235.36,652.74,207.05,641.07Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 715.94,
    cy: 505.84,
    rx: 60.7,
    ry: 79.15,
    fill: "#636780"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M747.41,462.93c-25.18,9.65-43.56,40-43.56,75.95,0,38.42,21,70.44,48.84,77.64,25.17-9.65,43.56-40,43.56-75.95C796.25,502.15,775.25,470.13,747.41,462.93Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M536.35,521.87l1.13-28.73s-5.64-12.4-11.27-13.52-18.59-1.83-18.59-1.83-10.14,41.26-3.38,53.66S536.35,521.87,536.35,521.87Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M536.35,521.87l1.13-28.73s-5.64-12.4-11.27-13.52-18.59-1.83-18.59-1.83-10.14,41.26-3.38,53.66S536.35,521.87,536.35,521.87Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M432.41,518.77s-3.49-39.84,18.4-40.56c2.82-.09,5.64-.16,8.45-.43,15.17-1.47,56.56-4.66,51.6,4.79,0,0-9.86,34.65-3.1,43.38Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M742.69,592.64l29.36.85s5.07-54.09,6.76-58.31,2.54-24.51-2.95-27.46S752,501.17,752,501.17L738.46,532l-1.05,27.89Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M742.69,592.64l29.36.85s5.07-54.09,6.76-58.31,2.54-24.51-2.95-27.46S752,501.17,752,501.17L738.46,532l-1.05,27.89Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M671.7,502.86l-.13-6a3.47,3.47,0,0,1,3.62-3.54c14.56.61,67.52,3.15,76.79,7.88,0,0-10.14,75.42,1.06,93.38L749.24,655l-129.72-9.72Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M661.56,407.61c3.6-.36,7.89-.74,12.68-1.12v7.21H661.56Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M786.84,414.8v.91H774.17v-5.48A54.13,54.13,0,0,1,786.84,414.8Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M429.46,503.18a1.18,1.18,0,0,1,.48-.75,1.69,1.69,0,0,1,.87-.08h0c0,.32,0,.51,0,.51h0a19.56,19.56,0,0,0-1.81,1.85C429.18,504.2,429.31,503.69,429.46,503.18Zm45.89-13.46a1.55,1.55,0,0,0,0-.21,44.29,44.29,0,0,1,2.19-4.68C476.74,486.37,476,488,475.35,489.72Zm6.84-12.94c-1.08,1.61-2.39,3.69-3.68,6.1A28.34,28.34,0,0,1,482.19,476.78ZM303.52,616.72c5.09.2,9.33.11,9.33.11C311.93,617.25,307.84,617.06,303.52,616.72Zm9.34.1c.19-.12,2.07-1.22,6.46-.78C319.32,616,315,615.85,312.86,616.82ZM483.67,539.9l1.86-32s-.69,16.34-.46,23.41a23,23,0,0,1-1.4,8.6Z",
    transform: "translate(-48.43 -32.93)",
    fill: "url(#ceac7335-2455-461d-90f8-41e05a42a239-70)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M377.25,601.18s-.53,1.64-1.23,3.72c-1.14,3.39-2.75,8-3.3,8.43s-4.81.71-9.45,1A29.22,29.22,0,0,1,343.35,608s2.43-1.75,5-3.78,5.27-4.33,5.82-5.46c.77-1.55,5.17-4.22,7.82-5.72,1.19-.68,2-1.12,2-1.12Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#f899a5"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M371.63,615.31s-46.76-2.15-49.55-2.77-3.36-3.9-3.36-3.9c-.93-2.18,4-1.71,4-1.71h0c.5.08,6,1,11.18,1.66h0c4.15.53,8.08.89,9,.5h0c2.09-.87,6.26-.5,6.26-.5-2.37-7.84-9.55-9.71-12.62-10.15l.19-.19a15.7,15.7,0,0,1,2.67-2c9.53.39,14.57,13.53,14.57,13.53l.08,0c1.08.34,12.57,3.9,14.85,4.23h0C371.28,614.38,371.63,615.31,371.63,615.31Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#f3b4b4"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M347.18,619.48c-.18.59-1,1-2.34,1.11a15.2,15.2,0,0,1-2.18,0h0a49.52,49.52,0,0,1-13-2.92c-.72-.25-1.4-.47-2.06-.66l-.08,0a28.33,28.33,0,0,0-4.86-1c-4.24-.44-6.05.66-6.23.78h0s-4.1.09-9-.11h0a73.14,73.14,0,0,1-11.23-1.18h0c-.53-.11-1-.24-1.49-.37a10.4,10.4,0,0,1-2.51-1c-5.16-3.1,12.22-5.19,12.22-5.19a9.06,9.06,0,0,0,5.26-2.54l.18-.2.44-.44,0,0a23.9,23.9,0,0,1,2.11-1.64l.64-.43c3.46-2.34,8.12-4.84,8.12-4.84a19.74,19.74,0,0,0,8.61-4.92,10.21,10.21,0,0,0,1.2-1.42h0l9.61-2.48,6.62,15.9s.05.86.1,2.15C347.42,611.54,347.61,618.08,347.18,619.48Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#f899a5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M344.84,620.59a15.2,15.2,0,0,1-2.18,0h0a49.52,49.52,0,0,1-13-2.92c-.72-.25-1.4-.47-2.06-.66l-.08,0a28.33,28.33,0,0,0-4.86-1c-4.24-.44-6.05.66-6.23.78h0s-4.1.09-9-.11h0a73.14,73.14,0,0,1-11.23-1.18h0c-.53-.11-1-.24-1.49-.37a11.91,11.91,0,0,1,1.93-.08h0c.49.06,6.05.74,11.23,1.17h0c4.18.35,8.12.54,9,.11h0c2.05-1,6.23-.78,6.23-.78-2.7-7.73-10-9.28-13.05-9.59.06-.07.13-.13.18-.2l0,0a16.51,16.51,0,0,1,2.55-2.08h.2c9.41.15,14.95,12.87,14.95,12.87l.08,0c1.09.29,12.73,3.36,15,3.59h0A5.73,5.73,0,0,1,344.84,620.59Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M345.39,621.78s-46.81-.12-49.62-.61-3.53-3.76-3.53-3.76c-1-2.13,3.89-1.87,3.89-1.87h0c.49.06,6,.74,11.23,1.18h0c4.17.34,8.12.53,9,.11h0c2-1,6.23-.78,6.23-.78-2.71-7.73-10-9.28-13.05-9.59l.18-.2a17.09,17.09,0,0,1,2.58-2.11c9.54,0,15.15,12.88,15.15,12.88l.08,0c1.09.28,12.73,3.35,15,3.58h0C345,620.86,345.39,621.78,345.39,621.78Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#f3b4b4"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M377.25,601.18s-.53,1.64-1.23,3.72c-.28-.19-9.49-6.32-13-10.34a7.61,7.61,0,0,1-1.06-1.49c1.19-.68,2-1.12,2-1.12Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M404.19,580.9l-1.66,5.37-15.9,8.66s-4.3,3.05-5,4.49a4.48,4.48,0,0,1-2.54,2,35.24,35.24,0,0,0-2.2,3.06s-9.44-6.26-13-10.34c-1.1-1.26-1.63-2.32-1.13-2.91,2.08-2.5,14.56-11.48,14.56-11.48s7.62-10,7.95-9.82,4.16-3.51,6.41-5.6l1.54-1.44Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#bdd3e8"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M480,472.79l-15.48,27.38L458.84,511l-30.25-4.41.68-1.45,2.56-5.37,1.17-2.46.18-.33,3.35-6.07.19-.25,2.43-3.44,4.89-6.91a4.42,4.42,0,0,0,1.6-.42,3.78,3.78,0,0,0,1.83-2.08c1.73-4.28-1.44-12.51-1.44-12.51s11.48-28,15.46-12.59c2.94,11.43,11.67,16.95,16,19A22,22,0,0,0,480,472.79Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#f899a5"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M428,566.92v2.65s10,9.57,8.68,17.37,1.47,17.52,1.47,17.52l10.06-.72-1.52-35.64Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#bdd3e8"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M448.21,603.74l-10.06.72s-2.79-9.71-1.47-17.52S428,569.57,428,569.57v-2.65l18.69,1.18.1,2.32Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.05
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M392.51,565.89a84,84,0,0,0-8.82,9.57c-3.54,4.71-9.57,11.48-9.57,11.48l-7.21,4.27-3,2.91c-1.1-1.26-1.63-2.32-1.13-2.91,2.08-2.5,14.56-11.48,14.56-11.48s7.62-10,7.95-9.82,4.16-3.51,6.41-5.6Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.05
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M347.28,608.08a9.73,9.73,0,0,0-.83.8s-.15,4.7-3.83-6.34-12.81-8.39-12.81-8.39a.17.17,0,0,1-.07-.2c0-.3.53-.82,1.2-1.42v0l9.61-2.48,6.62,15.9S347.23,606.79,347.28,608.08Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M381.19,545.28l-5.6.15-3.83,5.45s-6.33,6.77-8.24,8.46-14.28,13.32-17.81,19.36c0,0-3.24,1.62-3.24,3.24s-6.18,6.33-6.18,6.33-6.48,4.41-5.6,5c0,0,9.13-2.65,12.81,8.39s3.83,6.33,3.83,6.33a8.59,8.59,0,0,1,2.21-1.74c.88-.32,5.07-6.35,6.36-6.5a6.36,6.36,0,0,0,2.62-1.18l7.5-7.36,7.22-4.27s6-6.77,9.56-11.48a84.69,84.69,0,0,1,8.83-9.57Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#bdd3e8"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M353.22,580.91s10,4.85,9.57,5.88S353.22,580.91,353.22,580.91Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M361.12,579.73s.78,4.37,4.76,4.17S361.12,579.73,361.12,579.73Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M347.18,592s.59,2.5,4.27,2.94S347.18,592,347.18,592Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M384.65,580.91s4.85,2,5.29,4.78S384.65,580.91,384.65,580.91Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M372.72,591.21c1.88.81,7.29,6.88,7.18,7.54S372.72,591.21,372.72,591.21Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M381.33,586.9a3.25,3.25,0,0,1,3.32.7C386,589,381.33,586.9,381.33,586.9Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M417,538.81s-18.77-6.08-17.33,0S417,548.3,417,548.3Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#f899a5"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M480,472.79l-15.48,27.38L458.84,511l-30.25-4.41.68-1.45a17.46,17.46,0,0,1,2.41-2.7,10,10,0,0,1,.15-2.67,5.19,5.19,0,0,1,1.35-2.79l.12-.11c1.42-1.25,2.77-4.48,3.42-6.21.26-.69.4-1.15.4-1.15l2-2.29,6.49-7.33,1.83-2.08,1.72-1.94L443,484.63s-2.94,5.3-3.09,6-5,7.21-5,7.21-8.24,7.22,6.48,7.36S465.09,491,465.09,491l12.42-19.24A22,22,0,0,0,480,472.79Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "398.36 537.49 392.59 537.09 379.56 536 379.56 534 398.26 535.17 398.36 537.49",
    opacity: 0.1
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M477.46,470.21s2.65,2.94,5.3,3.09c0,0-4.86,5.15-6.63,10.16,0,0-8.26,13.9-2.35,18.69s9.34,5.74,9.34,5.74l-1.79,32s4.37,22,6,23.64,1.18,5.3,1.18,5.3-1.07,3.68.05,5,1.42,8.1,1.42,8.1-6.62-3.39-8-3.39-5-6.92-5-6.92l-36-2.5-15.83-1.32,2.5-44s-7.21-11.83,2.65-20.93c0,0-.38-3.81,1.62-5.57s3.83-7.36,3.83-7.36l12.07-13.64h0l-6.18,8.79s-2.95,5.3-3.09,6-5,7.22-5,7.22-8.24,7.21,6.48,7.36,23.7-14.28,23.7-14.28Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#e6ebef"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M465.68,528.21s5.12,3.75,10.6,3.9S465.68,528.21,465.68,528.21Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M472.3,516.32s4.05-2,6.33-.33S472.3,516.32,472.3,516.32Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M470.39,523s.26,2.36,6.26,2.65S470.39,523,470.39,523Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M482.31,473.3l1.26.67a28.1,28.1,0,0,0,7.94,1.69c5.08.44,9.5,5.3,10.38,9.93.22,1.16.4,2.71.55,4.37a89.74,89.74,0,0,1-.28,18c-.48,4.23-1,9-.71,9.7.44,1.32-2.43,21.86-2.43,21.86s-.66,16.78-4.86,18.33-27.6,1.54-27.6,1.54l-9.93-17.22,23.18,1.1a22.68,22.68,0,0,0,2.87-11.92c-.22-7.07.44-23.41.44-23.41s-14-3-11.16-13.93S482.31,473.3,482.31,473.3Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#f899a5"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M438.15,604.46s-9.35,3.09-13,1.47-11.59-7.8-11.59-7.8-5.1-5-9.95-10.59l-.62-.72h0c-4.2-4.89-8-10-8-12.53a10.65,10.65,0,0,0-.39-3.11,13,13,0,0,0-2-4.07,12.15,12.15,0,0,0-1.72-1.94l-15.31-19.73s4.42-4.71,4.42-6,5.3-8.53,12.07-4.7c2.85,1.6,9.66,7.57,16.6,13.94,9.55,8.76,19.32,18.29,19.32,18.29s.69.74,1.7,1.89c2.59,3,7.27,8.65,7.64,11.51C437.86,584.29,438.15,604.46,438.15,604.46Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#bdd3e8"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M429.7,568.81c-7.25,7.22-18.16,16.9-26.08,18.73l-.21.05-.41-.77h0l-8.36-15.64-2.12-4,.11-.11,16.06-18.47c9.55,8.76,19.32,18.29,19.32,18.29S428.69,567.66,429.7,568.81Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.05
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M488.31,582.34v3.35s4.64,16.38-3.75,21c-4.24,2.35-13.27,2.91-21.17,2.89a22.42,22.42,0,0,1-22.13-18.45,13.4,13.4,0,0,1-.09-4.75s-3.75-26.83-4.64-27c0,0-21.09,24.15-34,26.93l-10.9-20.38,17.41-20s12.92-20.53,16.67-22.41,7.51-7.14,7.51-7.14,15.13-12.62,25.17,8.69,16.56,38.52,19,44.91c0,0,3.54,7.24,5.74,7.22h.07A5.16,5.16,0,0,1,488.31,582.34Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#bdd3e8"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M436.09,558.24a21.82,21.82,0,0,0,4.52-7.73c1.67-4.86-.5,4.93-4.08,8.83Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M416.44,436.73c.15,1.4,1.2,2.65,2.28,3.82a73,73,0,0,0,7.38,6.95c1.12.93,2.33,1.9,2.7,3.11a4.89,4.89,0,0,1-.18,2.7,46.29,46.29,0,0,1-3.92,9.74,6,6,0,0,0-1.09,3.32c.27,2.62,4,4.09,6.72,5.82,3.57,2.31,5.63,5.8,5.5,9.28-.22,5.43-5.37,10.12-6.58,15.48a26,26,0,0,0,9.73-2c2.86-1.35,5-3.7,4.88-6.2a1.75,1.75,0,0,1,.15-1.15,2.47,2.47,0,0,1,1.4-.72c2.67-.65,5.93-.44,7.89-1.93s1.51-4.11.67-6.2c-2.28-5.72-5.58-11.22-7.57-17a12.2,12.2,0,0,1-.86-6.08c.36-2,1.59-3.91,2.64-5.81a37,37,0,0,0,4.38-13.34c.32-2.64.31-5.39-1.08-7.83-1.55-2.75-4.84-4.93-8.73-5.78-7.51-1.65-11.51,2-17.38,4.43C421,429.2,416,432.53,416.44,436.73Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#4b3648"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M429.25,496.5c.61,0,1.22-.07,1.83-.12,1.25-5.31,6.32-10,6.54-15.35.13-3.48-1.94-7-5.5-9.29-2.68-1.73-6.45-3.2-6.72-5.81a6.05,6.05,0,0,1,1.09-3.33,46.29,46.29,0,0,0,3.92-9.74,4.89,4.89,0,0,0,.18-2.7c-.37-1.21-1.58-2.18-2.7-3.1a74.27,74.27,0,0,1-7.38-7c-1.08-1.16-2.13-2.41-2.28-3.81-.46-4.2,4.51-7.54,8.93-9.39,4.59-1.94,8-4.56,12.94-4.82-5.88-.38-9.59,2.66-14.73,4.82-4.42,1.85-9.39,5.19-8.93,9.39.15,1.4,1.2,2.65,2.28,3.81a74.27,74.27,0,0,0,7.38,7c1.12.92,2.33,1.89,2.7,3.1a4.89,4.89,0,0,1-.18,2.7,46.29,46.29,0,0,1-3.92,9.74,6.05,6.05,0,0,0-1.09,3.33c.27,2.61,4,4.08,6.72,5.81,3.57,2.31,5.63,5.81,5.5,9.29C435.61,486.45,430.46,491.15,429.25,496.5Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 397.67,
    cy: 415.42,
    r: 23.52,
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 398.11,
    cy: 414.54,
    r: 23.52,
    fill: "#f899a5"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M432.06,436.44c-1.84-.58-3.77-1.22-5-2.85s-1.45-4.57.12-5.91a10.34,10.34,0,0,1,2.83-1.23c3.95-1.75,4.62-7.88,7.3-11.71a8.78,8.78,0,0,1,8.1-3.9,39,39,0,0,1,4.89,1.44c3.91,1.06,8.09.22,12.06.94,7.8,1.43,13.77,8.77,17,17,1.49,3.79,2.53,7.8,3.71,11.75a155.64,155.64,0,0,0,6.4,17.4,12.23,12.23,0,0,0,2.19,3.69c2.5,2.55,6.92,2.36,8.46,5.79.85,1.9.45,4.23.17,6.38a50.76,50.76,0,0,0,1.84,21.63c1.69,5.36,4.92,10.78,9.85,11.55-1.89,2.64-5.59,2.39-7.93.5s-3.74-4.93-5.31-7.7a49,49,0,0,0-4.53-6.65,9.35,9.35,0,0,0-3.43-2.95c-3.36-1.36-6.93,1.42-9.93,3.84-2.47,2-5.14,3.87-8.09,4.25a6.5,6.5,0,0,1-7.15-4.39c-1.13-3.83,1.15-9-1.34-11.78-.9-1-2.22-1.37-3.3-2.14-3.18-2.26-3.57-7.43-3.14-11.81s1.33-9.08-.37-12.93a15.57,15.57,0,0,0-4-5,88,88,0,0,0-24.16-15.86",
    transform: "translate(-48.43 -32.93)",
    fill: "#4b3648"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.29,499a6.5,6.5,0,0,1-7.16-4.39c-1.13-3.82,1.16-9-1.34-11.78-.9-1-2.22-1.37-3.29-2.13-3.19-2.26-3.58-7.43-3.14-11.81s1.33-9.09-.38-12.94a15.68,15.68,0,0,0-4-5A88,88,0,0,0,431.82,435l2.78.66c-1.84-.58-3.78-1.23-5-2.85s-1.45-4.57.13-5.92a10.26,10.26,0,0,1,2.82-1.22c4-1.75,4.62-7.88,7.3-11.71a9.66,9.66,0,0,1,3.37-3,9.19,9.19,0,0,0-6.05,3.87c-2.68,3.83-3.34,10-7.3,11.71a10.34,10.34,0,0,0-2.83,1.23c-1.57,1.34-1.38,4.29-.12,5.91s3.2,2.27,5,2.85l-2.77-.65A88,88,0,0,1,453.3,451.8a15.57,15.57,0,0,1,4,5c1.71,3.85.81,8.55.37,12.93s0,9.55,3.14,11.81c1.08.77,2.4,1.12,3.3,2.14,2.49,2.79.21,7.95,1.34,11.78a6.5,6.5,0,0,0,7.15,4.39,10.38,10.38,0,0,0,3.22-1A4.94,4.94,0,0,1,475.29,499Z",
    transform: "translate(-48.43 -32.93)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.57,508.16c-2.34-1.89-3.74-4.93-5.3-7.69a47.52,47.52,0,0,0-4.54-6.65,9.18,9.18,0,0,0-3.43-2.95,6.2,6.2,0,0,0-5.26.58,5.09,5.09,0,0,1,2.58.31,9.27,9.27,0,0,1,3.43,2.95,49,49,0,0,1,4.53,6.65c1.57,2.77,3,5.81,5.31,7.7,2,1.58,4.88,2,6.89.55A6.49,6.49,0,0,1,506.57,508.16Z",
    transform: "translate(-48.43 -32.93)"
  }))), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "802 561.62 782.84 561.9 743.26 489.97 736.65 477.96 741.72 447.54 745.62 454.9 802 561.62",
    fill: "#dce0ed"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "628.76 473.17 620.88 485 597.3 453.12 586.51 438.52 592.99 429.79 597.95 435.81 628.76 473.17",
    fill: "#dce0ed"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M646.38,468.73c0,.61.07,1.24.11,1.87l-.76,15.45-10.79-14.6,6.48-8.73Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "745.62 454.9 743.26 489.97 736.65 477.96 741.72 447.54 745.62 454.9",
    opacity: 0.1
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M624,491.17s-9.46-70.65,25-81.22a8.74,8.74,0,0,1,1.35-.28c7.93-.95,81.8-9.47,120.15.65,0,0,26.2,3.95,25.92,18L784.8,600.46H765.93l6.19-113.8s9-49.58-5.91-53-82.82-9-106.76-2.25c0,0-17.47-3.95-14.65,39.15l-1.13,23.1Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#dce0ed"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M681.42,512.15a10.88,10.88,0,0,0-4.44-9.72c-5.28-4-21.55-12.67-21.55-12.67l-5.28.42-15.84,39.3,1.05,83.45,28.52,35.28Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M681.42,512.15a10.88,10.88,0,0,0-4.44-9.72c-5.28-4-21.55-12.67-21.55-12.67l-5.28.42-15.84,39.3,1.05,83.45,28.52,35.28Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M567.62,599.62l.56-85.64s-2.53-33.24,17.33-33.8c0,0,46.83.34,67.18,6.95a4.54,4.54,0,0,1,2.56,6.56c-4,7.05-10.88,25.72-14.18,73.6v51.34Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "617.99 621.41 532.77 619.42 532.69 619.42 490.81 618.45 495.66 562.46 518.9 563.31 592.85 579.79 615.45 615.28 617.99 621.41",
    fill: "#01bf71"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "617.99 621.41 532.77 619.42 532.69 619.42 490.81 618.45 495.66 562.46 518.9 563.31 592.85 579.79 615.45 615.28 617.99 621.41",
    opacity: 0.1
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    points: "617.99 621.41 532.77 619.42 531.37 581.9 592.85 579.79 615.45 615.28 617.99 621.41",
    fill: "#01bf71"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M581.12,652.35l-41.88-1,4.86-56s13.1,20.92,35.7,19.44Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#fff",
    opacity: 0.1
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M881.7,697.64c-1.69,16.06-13.1,13.52-13.1,13.52l-2.13-.19-21.11-1.92.85-24.93s11.49-.78,21.41,1.29C875.54,687.05,882.45,690.51,881.7,697.64Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#dce0ed"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M588.46,454.27S549.59,472,546.77,477.08s-22,27-22,27l8.31,14,38.45-30.57Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#4c4981"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M558.84,544.92l-18-2.69-13.24,15.62S509.15,567,507,571s-8.86,15.72-11.82,15.81-5.73,4.41-5.75,6.12-11.27,21.35-14.06,22.48-7.63,7.51-7.51,8.77S457.36,638,457.36,638s-18,28.17-20.68,29.07S423.63,686.16,421,688.32s-10,4.1-9.1,5.85,19,26.49,17.9,33.5c0,0,13.47-10.66,14-13.94S461,693.15,461,693.15l87.31-90.68,16.83-57.15Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#ceddf9"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M607.18,574.05s3.59,41.22-8.31,47.46-20,5.52-22.29,8.27-16.24,5.18-17.72,7.68-40.57,24.35-40.57,24.35S491.55,677.57,487.36,681s-27,13.46-30.89,18.18-28.31,20.19-28.31,20.19-7.15-22-15.37-23.93c0,0,19.76-3.89,20.93-7s7.07-6.45,7.07-6.45,28.13-16.32,29-20,7.8-8.92,7.8-8.92,11.17-15.27,15.28-16.74,28.48-26.49,28.48-26.49,16.57-8.76,18.41-11.64S573,579,573,579l-35.79-44.47,11.32-3.48,33.53,9,6,10.87Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M609.2,574.65s3.6,41.22-8.3,47.46-20,5.53-22.3,8.27-16.24,5.19-17.72,7.68-40.56,24.36-40.56,24.36-26.74,15.75-30.94,19.15-27,13.47-30.89,18.19-28.31,20.18-28.31,20.18S423,698,414.81,696c0,0,19.77-3.88,20.93-7s7.07-6.46,7.07-6.46,28.13-16.32,29-20,7.81-8.93,7.81-8.93,11.17-15.27,15.28-16.73,28.47-26.5,28.47-26.5,16.57-8.76,18.41-11.64-14.2-41-14.2-41l11.68-22.7,11.32-3.47,33.53,9,6,10.87Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#ceddf9"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M649,466.77l-27.35,19s-33.05-12.26-20-17.18c8.56-3.23,11.64-19.9,12.74-31,.58-5.78.61-10,.61-10s37.29-.06,30.43,11.84a18.73,18.73,0,0,0-2.28,10.76C643.67,459,649,466.77,649,466.77Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#fec2be"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M643.09,450.2a26.22,26.22,0,0,1-28.76-12.57c.58-5.78.61-10,.61-10s37.29-.06,30.43,11.84A18.73,18.73,0,0,0,643.09,450.2Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M662.43,431.5a26.28,26.28,0,1,1,.59-2.41C662.86,429.89,662.67,430.7,662.43,431.5Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#fec2be"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M609.91,456.11s-4.59,0-4.88,6.53-4.93,6.05-4.93,6.05l-21.56,22.39s-9.68,23.18-9.6,24.12-2.18,4.86-1.67,6.84-.2,8-2,7.47-4.8,1.32-4.76,4.27-15.15,12-14.53,14.2,43.25,24.85,43.25,24.85l17.74,13.75,16.56-30.85,13.8-42.51L645,488.54l6.35-7.1-2.92-16.66s-2.62-7.21-4.76-6.2-10,9.5-17.38,10.24-11.69,1.64-13.41,0S600.71,466,609.91,456.11Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M611.39,453.94s-5.46.16-5.76,6.68-4.93,6.05-4.93,6.05l-21.56,22.39s-9.68,23.17-9.59,24.12-2.19,4.85-1.68,6.84-.19,8-2,7.47-4.81,1.32-4.77,4.27-15.15,12-14.52,14.2,43.24,24.85,43.24,24.85l17.75,13.75,16.56-30.86,13.8-42.51,7.74-24.67,6.34-7.1-2.92-16.66s-2.62-7.21-4.76-6.2-10,9.5-17.37,10.23-11.69,1.65-13.41,0S612.86,463.28,611.39,453.94Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M611.19,454.61s-5.47.16-5.76,6.68-4.93,6.06-4.93,6.06l-21.56,22.38s-9.68,23.18-9.59,24.12-2.19,4.86-1.68,6.84-.19,8-2,7.47-4.8,1.32-4.76,4.27-15.15,12-14.52,14.2,43.24,24.86,43.24,24.86l17.74,13.74,16.56-30.85,13.81-42.51,7.73-24.68,6.35-7.1-2.92-16.66s-2.62-7.21-4.76-6.19-10,9.49-17.37,10.23-11.7,1.65-13.42,0S612.66,464,611.19,454.61Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#fff"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M611.38,454.58a40.53,40.53,0,0,1-7.55-1.48c-2.64-1-12.41-.22-12.41-.22s-11.22.69-13.29,3.93-11,20.77-14.06,21.87-21.15,30.22-24.85,32.78-19.64,33.79-19.64,33.79,11.78-5.56,17.17,2.58c.14.21.28.42.41.65,5.18,9.08,10,2.08,10,2.08s17.15-15.62,18.52-18.34,11.51-23.18,14.12-28.83,24.71-33.56,25.45-34.8S611.38,454.58,611.38,454.58Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M611.38,454.58a63.27,63.27,0,0,1-8.89-1.88c-2.65-1-12.42-.22-12.42-.22s-11.22.69-13.29,3.92-11,20.78-14.06,21.87-21.15,30.22-24.85,32.79-19.64,33.79-19.64,33.79,11.78-5.56,17.18,2.58c.13.2.27.42.4.65,5.18,9.07,10,2.08,10,2.08s17.16-15.63,18.52-18.34,11.51-23.18,14.12-28.83,24.71-33.56,25.45-34.81S611.38,454.58,611.38,454.58Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#4c4981"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M644.21,455.62s14.18,10.29,16,13.41,20.39,12.88,20.39,12.88,7,12.92,5.95,17.57-2.16,9.08-1.25,11.56,1.47,2.46.12,5.73-.88,3.59,1,6.53-28,12-28,12-4,.62-4.43,2.53-23.34,52.32-26.65,60.33-13.77,40-22.55,40.45-2,.12-2,.12,1.35-26-4.05-35S604,560,604,560,639.49,457.88,644.21,455.62Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M644.21,455.62s15.53,10.7,17.35,13.81S682,482.31,682,482.31s7,12.92,5.95,17.57-2.16,9.09-1.25,11.56,1.47,2.46.12,5.73-.89,3.59,1,6.54-28,12-28,12-4,.63-4.43,2.53S632,590.58,628.67,598.58,614.9,638.53,606.12,639s-2,.12-2,.12,1.35-26-4.05-35,5.35-43.75,5.35-43.75S639.49,457.88,644.21,455.62Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#4c4981"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M662.23,558.55s-31.46,7-32.44,9-27,17.51-13.35,25S651.54,582,651.54,582l17-10.85Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#fec2be"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M676.29,516.61c.51.15,11.47,7.1,11.47,7.1s5.16,17.14,6.29,21.34,4,11.67,3.81,13.07,3.12,9.19-2.16,12.75-10.82,3-13.36,5.38-20.05,10-22.26,10.6,10.92-26.11-5.29-30.22c0,0,11.61,1.09,12.21-.94s1.27-7.33-.9-9.26-11.54-11.16-11.54-11.16Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#4c4981"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M663,429.09a7.22,7.22,0,0,1-3.13-3.28c-1.07-2.08-2.14-4.62-4.42-5.15-1.28-.31-2.83.07-3.78-.84-.74-.72-.72-1.89-.73-2.92a11.88,11.88,0,0,0-1.91-6.63,6.94,6.94,0,0,0-5.93-3.09c-3.25.22-6.08,3.18-9.28,2.59-1.41-.26-2.76-1.21-4.14-.84a4.07,4.07,0,0,0-1.46.82,21.27,21.27,0,0,0-6.67,9c-1.32,3.36-1.76,7-3.34,10.29-.63,1.28-1.84,2.65-3.2,2.25-2.12-.63-1-3.3-2.18-4.47a3.23,3.23,0,0,0-1.67-.67A26.21,26.21,0,1,1,663,429.09Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M615.23,430.61c1.36.4,2.57-1,3.2-2.24,1.58-3.25,2-6.93,3.34-10.29a21.23,21.23,0,0,1,6.68-9,4.06,4.06,0,0,1,1.45-.83c1.38-.36,2.74.58,4.14.84,3.2.6,6-2.37,9.28-2.59a6.94,6.94,0,0,1,5.93,3.1,11.74,11.74,0,0,1,1.91,6.62c0,1,0,2.2.74,2.92.94.92,2.49.54,3.78.84,2.28.54,3.34,3.07,4.42,5.15s3.25,4.26,5.42,3.36c.65-.27,1.18-.8,1.85-1,1.23-.41,2.7.26,3.8-.42,1.4-.86,1-3,.09-4.43s-2-3-1.43-4.53a6.14,6.14,0,0,1,1.51-1.94,9.61,9.61,0,0,0-.58-13.19c-.89-.8-1.93-1.42-2.8-2.24-1.75-1.64-2.68-3.94-4-6a18.28,18.28,0,0,0-6.37-6,9.1,9.1,0,0,0-3.7-1.29c-1.81-.14-3.59.54-5.4.72-6.06.61-11.27-4.18-17.2-5.54a4.88,4.88,0,0,0-4.07.48c-1.18.92-1.43,2.57-2,4-1.19,3.06-4.07,5.2-7.13,6.38-3.53,1.35-8,2.08-9.47,5.55-1.28,3,.38,6.44-.29,9.6-.52,2.47-2.37,4.4-3.8,6.48s-2.48,4.88-1.24,7.08a6.3,6.3,0,0,0,3.24,2.53c1.66.68,5.36.32,6.48,1.42S613.11,430,615.23,430.61Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#9a5e7f"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M674.47,546.66c.6.06,11.53,2,14.1,5.68S674.47,546.66,674.47,546.66Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M669,535s11.92,2.7,13.3,3.85S669,535,669,535Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M672.92,505.57s8.77,3.84,9.77,6.22S672.92,505.57,672.92,505.57Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M560.84,605c.91.64,22.45,16.62,20.69,17.2S560.84,605,560.84,605Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M560.68,615s12.62,6.1,10.51,8.65S560.68,615,560.68,615Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M608.79,407.29c.57-2.71-.57-5.64-.1-8.3,0,0,0,0,0,.05-1.26,2.92.33,6.33-.26,9.45A8.36,8.36,0,0,0,608.79,407.29Z",
    transform: "translate(-48.43 -32.93)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.23,416.74a2.57,2.57,0,0,0-.14.82,11.07,11.07,0,0,1,1.25-1.41,8.72,8.72,0,0,0,2.11-4.14,8.47,8.47,0,0,1-1.71,2.79A6.14,6.14,0,0,0,670.23,416.74Z",
    transform: "translate(-48.43 -32.93)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.58,425.7c-1.1.68-2.58,0-3.81.42-.67.23-1.2.75-1.85,1-2.17.9-4.35-1.27-5.42-3.35s-2.14-4.62-4.42-5.16c-1.28-.3-2.84.08-3.78-.84-.74-.71-.72-1.88-.74-2.91a11.85,11.85,0,0,0-1.9-6.63,7,7,0,0,0-5.94-3.1c-3.24.22-6.07,3.19-9.27,2.6-1.41-.27-2.77-1.21-4.15-.85a4.21,4.21,0,0,0-1.45.83,21.23,21.23,0,0,0-6.68,9,30.38,30.38,0,0,0-1,2.93c.17-.53.35-1.06.56-1.58a21.23,21.23,0,0,1,6.68-9,4.06,4.06,0,0,1,1.45-.83c1.38-.36,2.74.58,4.14.84,3.2.6,6-2.37,9.28-2.59a6.94,6.94,0,0,1,5.93,3.1,11.74,11.74,0,0,1,1.91,6.62c0,1,0,2.2.74,2.92.94.92,2.49.54,3.78.84,2.28.54,3.34,3.07,4.42,5.15s3.25,4.26,5.42,3.36c.65-.27,1.18-.8,1.85-1,1.23-.41,2.7.26,3.8-.42a2,2,0,0,0,.9-1.8A1.77,1.77,0,0,1,671.58,425.7Z",
    transform: "translate(-48.43 -32.93)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.83,427c-.62,1.28-1.84,2.64-3.2,2.24-2.12-.62-1-3.29-2.17-4.46s-4.82-.74-6.48-1.42a6.34,6.34,0,0,1-3.24-2.53,4.79,4.79,0,0,1-.42-3.39,5.47,5.47,0,0,0,0,4.74,6.3,6.3,0,0,0,3.24,2.53c1.66.68,5.36.32,6.48,1.42s.05,3.84,2.17,4.46c1.36.4,2.57-1,3.2-2.24a26.15,26.15,0,0,0,1.55-4.32A21.44,21.44,0,0,1,618.83,427Z",
    transform: "translate(-48.43 -32.93)"
  }))), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M574.21,477.3s-8.61,12.85-7.58,15.54S574.21,477.3,574.21,477.3Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M575.47,519.17s4.57,1.91,6.24,3.7S575.47,519.17,575.47,519.17Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M585.51,532.27s9.76,2.36,10.59,3.89S585.51,532.27,585.51,532.27Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M587.21,545.63s8.83,1.16,9.83,4.58S587.21,545.63,587.21,545.63Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M881.7,697.64c-1.69,16.06-13.1,13.52-13.1,13.52l-2.13-.19a21.57,21.57,0,0,1-3.36-12.06c0-5.59,1.78-10.53,4.51-13.5C875.54,687.05,882.45,690.51,881.7,697.64Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M555.22,487.22c-19.29,0-34.92,21.13-34.92,47.19s15.63,47.18,34.92,47.18,34.93-21.13,34.93-47.18S574.52,487.22,555.22,487.22Zm-4.93,84.51c-14.7,0-26.61-15.32-26.61-34.23s11.91-34.22,26.61-34.22,26.62,15.32,26.62,34.22S565,571.73,550.29,571.73Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#636780"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    points: "508.48 515.99 524.82 532.04 530.73 517.67 507.07 503.87 508.48 515.99",
    fill: "#636780"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    points: "532.57 357.07 546.79 358.8 552.07 365.07 544.07 401.07 527.07 459.07 515.91 498.89 508.07 523.07 503.07 555.07 498.07 577.07 483.07 592.07 452.57 556.07 447.57 544.07 435.57 519.57 466.57 505.07 500.57 502.07 516.57 461.07 529.57 413.57 532.57 357.07",
    fill: "#01bf71"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "244.82 528.66 226.23 684.72 460.31 674.86 433.27 598.24 388.2 568.94 491.3 570.63 491.86 527.82 450.17 518.8 366.23 512.04 303.13 509.23 242.85 528.94",
    fill: "#01bf71"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "244.82 528.66 226.23 684.72 460.31 674.86 433.27 598.24 388.2 568.94 491.3 570.63 491.86 527.82 450.17 518.8 366.23 512.04 303.13 509.23 242.85 528.94",
    opacity: 0.1
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M613.06,717.11c0,38.78-12.89,74.08-48.64,70.22-45.09-1-48.63-31.44-48.63-70.22s21.77-67.64,48.63-67.64S613.06,678.33,613.06,717.11Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#636780"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M613.34,717.18c0-30-13.05-54.1-31.41-63.44-23.58,4.48-41.7,31.6-41.7,67,0,31.78,2.38,58,28.06,66.93C601.32,788.84,613.34,754.63,613.34,717.18Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    points: "610.57 623.32 596.82 639.07 621.57 634.82 640.07 617.82 656.57 584.82 679.82 570.57 736.82 578.32 789.57 580.32 809.04 563.03 787.32 560.07 765.32 559.57 710.07 558.32 644.32 556.57 630.82 592.57 620.57 617.32 610.57 623.32",
    fill: "#01bf71"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M848.18,720.46c-1.13,1.69-38,7.33-38,7.33l-102,18.59L533,748.91l-20.56-17.47-10.8,1.92-.44.08L356.92,759.05l-2.35-.33-39.32-5.61L109.88,723.84l2.3-29.81,1.36-17.6,2.81-36.53,2-9.58,18.29-1.68,8.54-.78,133.29-12.23,17.43-1.6,9.77-.89,95.21-13,138.87,3.38.56-42.82,54.93-169c12.11,2,11.83,10.14,11.83,10.14L560.3,561l-.57,97.75c97.25,9.82,100.39-11.37,115.77-4.23l18.6-59.43,163.37.85C864,603.84,848.18,720.46,848.18,720.46Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    points: "394.4 598.8 446.23 710.07 463.69 715.7 467.92 697.67 448.48 635.98 428.48 600.21 394.4 598.8",
    fill: "#01bf71"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    points: "394.4 598.8 446.23 710.07 463.69 715.7 467.92 697.67 448.48 635.98 428.48 600.21 394.4 598.8",
    opacity: 0.15
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 360.66,
    cy: 721.33,
    rx: 93.87,
    ry: 106.48,
    fill: "#636780"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M442.58,654.43c-49.12,3.42-88,49.68-88,106.26,0,45.61,25.28,84.52,60.81,99.68,49.12-3.42,88-49.68,88-106.26C503.39,708.5,478.11,669.59,442.58,654.43Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M157.48,568.07,152.83,590l-14.22,67.11-61.13-5.92s-3.66-11.26,5.92-15.49c0,0,3.14-38.13,14.44-50.14a11.39,11.39,0,0,1,4.43-3.09Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M152.83,590l-14.22,67.11-61.13-5.92s-3.66-11.26,5.92-15.49c0,0,3.14-38.13,14.44-50.14Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#fff",
    opacity: 0.1
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M295.23,574C303.11,587.22,284,709.19,284,709.19L133.82,684.4l5.35-106.76c3.1-19.15,14.37-21.4,14.37-21.4,53-26.76,174.64-32.4,174.64-32.4,111,4.22,212.11,36.9,212.11,36.9C414.1,541.31,295.23,574,295.23,574Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M284,709.19,133.82,684.4l5.35-106.76c3.1-19.15,14.37-21.4,14.37-21.4S263.11,545.81,295.23,574C303.11,587.22,284,709.19,284,709.19Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M268.09,702.15,142.55,681,147,589.91c2.59-16.34,12-18.26,12-18.26s91.62-8.9,118.47,15.14C284.1,598.08,268.09,702.15,268.09,702.15Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.33,
    cy: 594.29,
    rx: 17.18,
    ry: 31.27,
    opacity: 0.1
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.33,
    cy: 593.45,
    rx: 17.18,
    ry: 31.27,
    fill: "#dce0ed"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M260,603.28s-7,1.12-3.38,10.42,4.22,14.08,4.22,14.08,7,3.67,6.76-8.45S260,603.28,260,603.28Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#f0f0f4"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.22,
    cy: 581.9,
    rx: 16.06,
    ry: 29.22,
    opacity: 0.1
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.22,
    cy: 581.05,
    rx: 16.06,
    ry: 29.22,
    fill: "#dce0ed"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M167.9,590.88s-7,1.13-3.38,10.43,4.23,14.08,4.23,14.08,7,3.66,6.76-8.45S167.9,590.88,167.9,590.88Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#f0f0f4"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M238,600.74c-1.12,11.55-6.76,97.18-6.76,97.18l-9.56-1.6-5.31-.87-7.08-1.19-.86-.14-27.89-4.65,5.51-90.83A11.36,11.36,0,0,1,197.59,588a8.06,8.06,0,0,1,.85,0c1.93.17,4,.37,6.17.61.91.1,1.84.2,2.77.32,2.68.32,5.45.71,8.16,1.15,1.38.24,2.74.49,4.09.75,2.27.45,4.47.95,6.5,1.52,1.37.38,2.68.79,3.88,1.24C235.05,595.41,238.34,597.76,238,600.74Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M197.59,588,192.13,690l-3.1-.28,5.41-101.41A11.29,11.29,0,0,1,197.59,588Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M207.38,588.92,202.27,692h-4.79l7.13-103.41C205.52,588.7,206.45,588.8,207.38,588.92Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M219.63,590.82l-8.06,103.44h-3.11v-.14l7.07-104C216.92,590.31,218.28,590.56,219.63,590.82Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M230,593.58l-8.29,102.74v.2l-5.35-.57,0-.5,9.72-103.11C227.5,592.72,228.81,593.13,230,593.58Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M115.44,673.14s-10.35-53.45,13.31-56.2,101.41,3,99.08,24.93S223,697.22,223,697.22l-16.05-3.59s12-50.28-6.76-52.18-64.86-7.19-64.86-7.19-12.47-2.11-5.28,42Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M115.44,678.21s-10.35-56.83,13.31-59.58,101.41,3,99.08,24.93S223,698.91,223,698.91l-16.05-3.59s12-50.28-6.76-52.18S135.3,636,135.3,636s-12.47,1.27-5.28,45.43Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#dce0ed"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M533,748.91l-20.84-.28c-15.21-67-40.29-108.73-40.29-108.73C463.39,635.39,371,636,371,636c-9.58,1.69-12.11,32.12-12.11,32.12s8.17,7,.28,11.55c-3.52,2-15.12,2.39-28.48,1.7-16.58-.86-35.9-3.38-45.88-6.49-18-5.64-3.67-16.06-3.67-16.06s2.54-3.38,4.23-22a75.25,75.25,0,0,1,10.28-30.69c.78-1.29,1.27-2,1.27-2a9.65,9.65,0,0,1,3.29-2.06c23.88-10,140.93-.48,140.93-.48l43.38,13.81c1.2.48,3.05,3.54,5.33,8.43C503.56,653.22,533,748.91,533,748.91Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M533,748.91l-20.84-.28c-15.21-67-40.29-108.73-40.29-108.73C463.39,635.39,371,636,371,636c-9.58,1.69-12.11,32.12-12.11,32.12s8.17,7,.28,11.55c-3.52,2-15.12,2.39-28.48,1.7-16.58-.86-35.9-3.38-45.88-6.49-18-5.64-3.67-16.06-3.67-16.06s2.54-3.38,4.23-22a75.25,75.25,0,0,1,10.28-30.69c.78-1.29,1.27-2,1.27-2a9.65,9.65,0,0,1,3.29-2.06c23.88-10,140.93-.48,140.93-.48l43.38,13.81c1.2.48,3.05,3.54,5.33,8.43C503.56,653.22,533,748.91,533,748.91Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M489.85,623.82c-40-15.56-150.4-7.3-150.4-7.3-11.72-10-33.77-10.68-43.8-10.41.78-1.29,1.27-2,1.27-2a9.65,9.65,0,0,1,3.29-2.06c23.88-10,140.93-.48,140.93-.48l43.38,13.81C485.72,615.87,487.57,618.93,489.85,623.82Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M345.93,620.74C343.4,629.47,333,664.41,333,664.41a147.84,147.84,0,0,0-2.29,16.91c-16.58-.86-35.9-3.38-45.88-6.49-18-5.64-3.67-16.06-3.67-16.06s2.54-3.38,4.23-22a74.87,74.87,0,0,1,11.55-32.68,9.65,9.65,0,0,1,3.29-2.06C315.87,605.75,347.85,614.13,345.93,620.74Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M345.93,620.74C343.4,629.47,333,664.41,333,664.41a147.84,147.84,0,0,0-2.29,16.91c-16.58-.86-35.9-3.38-45.88-6.49-18-5.64-3.67-16.06-3.67-16.06s2.54-3.38,4.23-22a74.87,74.87,0,0,1,11.55-32.68,9.65,9.65,0,0,1,3.29-2.06C315.87,605.75,347.85,614.13,345.93,620.74Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#fff",
    opacity: 0.1
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M371.71,398.91c-11.2,1.69-16.06,24.93-16.06,24.93L325.23,525.46l215.06,35.28,54.93-169C544.73,368.91,371.71,398.91,371.71,398.91Zm173,108.59s-1.27,9.72-9.51,10.57l-139.43-5.45-28.6-1.13-9.59-.37-.68,0s-10.57,1.9-8.88-7c0,0,11.62-84.5,32.12-90.84,0,0,2.13-.45,5.86-1.15,5.86-1.11,15.64-2.85,27.16-4.44,5.16-.71,10.67-1.39,16.34-2,15.49-1.58,32.14-2.43,45.92-1.1,0,0,102.67-9.51,95.28,13.31C570.72,417.93,549.17,500.53,544.73,507.5Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M357.6,511.12l-.68,0s-10.57,1.9-8.88-7c0,0,11.62-84.5,32.12-90.84,0,0,2.13-.45,5.86-1.15C378.58,426.65,354.7,476.36,357.6,511.12Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M357.6,511.12l-.68,0s-10.57,1.9-8.88-7c0,0,11.62-84.5,32.12-90.84,0,0,2.13-.45,5.86-1.15C378.58,426.65,354.7,476.36,357.6,511.12Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M376.53,719.55a13.6,13.6,0,0,1-12.73,7.14l-4.31-.19-40.61-1.75-14.64-.63L290.72,723,112.18,694l1.36-17.6,20.53,2.94,8.5,1.22,126.05,18L285.21,701l8.05,1.15,34.09-.25,36.9-.27a13.88,13.88,0,0,1,5.44,1,13.23,13.23,0,0,1,7.15,6.79A11.11,11.11,0,0,1,376.53,719.55Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M376.53,721.24a13.6,13.6,0,0,1-12.73,7.14l-59.56-2.57-13.52-1.13-190.4-30.89-15-2.43L77.2,690c-16.05-3.38-11.26-19.44-11.26-19.44,1.12-7.33,28.73-14.09,37.74-13.8,6.06.19,6.9,9.52,6.8,15.63,0,3-.32,5.21-.32,5.21l8.91,1.28,174.19,24.92,71-.52a13.64,13.64,0,0,1,12.59,7.84A11.11,11.11,0,0,1,376.53,721.24Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#dce0ed"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M90.72,666.94s7.61,9.29,19.44,10.7C110.16,677.64,105.37,667.22,90.72,666.94Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M88.75,693.14s-25.07-.57-25.07,13,15.78,15.78,15.78,15.78L303.4,765l63.66,1.12s22.25-17.74-.85-25.63L302,742.15,88.47,703S94.1,695.39,88.75,693.14Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M367.06,767.78l-63.66-1.12L104.28,728.34l-14.57-2.81-10.25-2s-15.78-2.26-15.78-15.78c0-9.7,12.92-12.15,20.21-12.76,2.87-.23,4.86-.19,4.86-.19,5.35,2.25-.28,9.85-.28,9.85l7.77,1.43L302,743.84l64.22-1.69C389.31,750,367.06,767.78,367.06,767.78Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#dce0ed"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M107.62,682.15l13.24-5.92,6.76-.28-.56,56.9-20.84-4.22L97.48,723l-4.22-23.66s1.69-9.86,2.53-10.7S107.62,682.15,107.62,682.15Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#dce0ed"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M107.62,682.15l13.24-5.92,6.76-.28-.56,56.9-20.84-4.22L97.48,723l-4.22-23.66s1.69-9.86,2.53-10.7S107.62,682.15,107.62,682.15Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M104.28,728.34l.24.29-14.64-2.82-.17-.28C82,713.08,81.33,703,83.89,695c2.87-.23,4.86-.19,4.86-.19,5.35,2.25-.28,9.85-.28,9.85l7.77,1.43C95.72,717.25,102.85,726.58,104.28,728.34Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M125.94,676q-3.72,1.42-6.87,3c-9.48,4.56-15.33,9.68-18.75,14.87l-15-2.43c6.49-13.48,22-19.64,22-19.64l3.14.71Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M109,671.73s-41.12,16.34-17.46,54.08l14.65,2.82s-29-33.24,21.4-52.68Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#dce0ed"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    points: "158.63 657.11 173.84 656.55 171.3 717.67 146.79 713.17 136.37 708.1 131.58 695.98 128.2 683.87 136.37 672.88 145.67 666.69 158.63 657.11",
    fill: "#dce0ed"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    points: "158.63 657.11 173.84 656.55 171.3 717.67 146.79 713.17 136.37 708.1 131.58 695.98 128.2 683.87 136.37 672.88 145.67 666.69 158.63 657.11",
    opacity: 0.1
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.94,
    cy: 688.66,
    rx: 7.32,
    ry: 12.39,
    fill: "#dce0ed"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M152.2,756.16c-2.11-10.77-10.35-13.1-10.35-13.1S126,738.42,125.58,756c0,0,.21,10.78,7.4,14.16l.42,12s.63,11.2-5.71,10.14-5.49-11-5.49-11-3.38-10.56-11.62-5.07c0,0-1.9,5.92,2.33,8.88,2.46,1.72,2.55,5.24,2.2,7.88a11.46,11.46,0,0,0,2.64,9.18,10.65,10.65,0,0,0,10.16,3.64,15.76,15.76,0,0,0,8.8-5.06,23.08,23.08,0,0,0,6.1-15.39l.31-15.46S154.31,766.94,152.2,756.16Zm-13,10.88a9,9,0,1,1,9-9A9,9,0,0,1,139.21,767Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#dce0ed"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M135.52,738.41a4,4,0,0,0-2,5.55c1.66,3.11,3.65,7.13,3.46,8.19-.32,1.79,3.7.32,4.22-.11s7.82,0,8.24-5-3.9-7.61-3.9-7.61l1.69-10.88-10-.84.11,9.93Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#636780"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M135.52,738.41a4,4,0,0,0-2,5.55c1.66,3.11,3.65,7.13,3.46,8.19-.32,1.79,3.7.32,4.22-.11s7.82,0,8.24-5-3.9-7.61-3.9-7.61l1.69-10.88-10-.84.11,9.93Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M138.26,738.21s3.38,11.62,1.9,12S138.26,738.21,138.26,738.21Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M142.06,735.46s3.38,11.62,1.9,12S142.06,735.46,142.06,735.46Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M182.56,700.46l-5.64,34.93s-7-.95-10.82-1.78a7.8,7.8,0,0,1-2.42-.75c-.2-.2-.61-.18-1.16-.07h0c-1.88.38-5.22,1.93-5.87.62a.93.93,0,0,0-.19-.27h0c-.66-.72-1.94-.2-3.18,0a2.7,2.7,0,0,1-2-.26c-1-.7-3.15.42-4.87.79-1.09.24-2,.19-2.46-.79a2.27,2.27,0,0,0-1.68-1.2h0c-1.62-.41-3.89-.13-5.2-.41-.52-.1-.87-.3-1-.65-.26-.76-1.71-1.12-3.26-1.42-1.89-.36-3.92-.63-4.07-1.39,0-.26-.23-.37-.51-.38a17.46,17.46,0,0,0-3.08.76h0c-.84.22-1.55.22-1.75-.38s-1.19-.6-2.3-.33c-.89.22-1.88.57-2.64.75s-1.18.18-1.26-.15c-.28-1.12-3.94,1.42-4.78-.84S100,710,115,690.6c0,0,4,.28,7.12.84a11.17,11.17,0,0,1,3,.84h0c1.07.61,3.36.48,5.43.63a7,7,0,0,1,3,.72,2,2,0,0,1,.85.9c.47,1.07,1.55,1.29,2.73,1.23,1.6-.1,3.38-.7,4-.38l.06,0c1.18.51,5.6,0,6.35.75l.06.07c.32.47,2,0,3.82-.26h0c1.37-.18,2.75-.2,3.5.55a3.82,3.82,0,0,0,2.74.81,16.13,16.13,0,0,1,3.59.14,1.53,1.53,0,0,1,.71.45c.71.89,2.43.77,4,.85a4.08,4.08,0,0,1,2.24.56,2.1,2.1,0,0,0,.81.34c2.16.5,6.79-.34,6.79-.34Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#636780"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M121.1,727.46c-.89.22-1.88.57-2.64.75-11.44-17.75-1.81-31.23,3.61-36.77a11.17,11.17,0,0,1,3,.84C113.56,705.54,118.9,722.1,121.1,727.46Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M128.24,727.41a17.46,17.46,0,0,0-3.08.76h0c-9.79-17.31.28-30.26,5.37-35.25a7,7,0,0,1,3,.72C122.58,705.62,125.83,720.53,128.24,727.41Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M137.07,731.25c-.52-.1-.87-.3-1-.65-.26-.76-1.71-1.12-3.26-1.42-8.59-15.68-.91-27.73,4.3-33.41,1.6-.1,3.38-.7,4-.38l.06,0C129.09,709,134.94,726.2,137.07,731.25Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M146.42,733.65c-1.09.24-2,.19-2.46-.79a2.27,2.27,0,0,0-1.68-1.2h0c-10-17.47.2-30.53,5.29-35.5l.06.07c.32.47,2,0,3.82-.26C137.21,710.34,144.53,729.42,146.42,733.65Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M156.44,733.13c-.66-.72-1.94-.2-3.18,0-10.44-17.34-.85-30.44,4.43-35.79a16.13,16.13,0,0,1,3.59.14C149.09,710.59,154.12,727.3,156.44,733.13Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M166.1,733.61a7.8,7.8,0,0,1-2.42-.75c-.2-.2-.61-.18-1.16-.07h0c-9.25-15.84-1.87-28.07,3.44-34a4.08,4.08,0,0,1,2.24.56,2.1,2.1,0,0,0,.81.34C158.89,712.73,164,728.45,166.1,733.61Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 390.74,
    cy: 726.41,
    rx: 45.91,
    ry: 67.6,
    fill: "#636780"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 389.19,
    cy: 727.39,
    rx: 33.38,
    ry: 54.79,
    opacity: 0.1
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 389.19,
    cy: 725.7,
    rx: 33.38,
    ry: 54.79,
    fill: "#f0f0f4"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 395.24,
    cy: 688.94,
    rx: 3.94,
    ry: 6.76,
    fill: "#636780"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 411.02,
    cy: 748.1,
    rx: 3.94,
    ry: 6.76,
    fill: "#636780"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 368.48,
    cy: 719.93,
    rx: 3.94,
    ry: 6.76,
    fill: "#636780"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 380.03,
    cy: 759.36,
    rx: 3.94,
    ry: 6.76,
    fill: "#636780"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M775.22,634.26s33,87.89,31.27,93.38c0,0,13.94,8.45,17.32,6.34s.43-41,.43-41l-6.34-34.22-7.19-20.28Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M775.22,634.26s33,87.89,31.27,93.38c0,0,13.94,8.45,17.32,6.34s.43-41,.43-41l-6.34-34.22-7.19-20.28Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.15
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 416.65,
    cy: 711.48,
    rx: 3.94,
    ry: 6.76,
    fill: "#636780"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 395.24,
    cy: 727.81,
    rx: 11.55,
    ry: 16.06,
    fill: "#636780"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M812,751.73c0,50.87-16.9,97.18-63.8,92.11-59.15-1.27-63.8-41.24-63.8-92.11S712.94,663,748.18,663,812,700.85,812,751.73Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#636780"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M812.35,751.81c0-39.38-17.12-71-41.21-83.22-30.93,5.88-54.7,41.46-54.7,87.87,0,41.69,3.13,76,36.81,87.8C796.58,845.82,812.35,801,812.35,751.81Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M836.91,730.18s-8.45,7.18-13.1,2.11c0,0-11.41-91.27-25.77-91.69l-49.44-.42s-5.91,2.53-8.45,13.52l-32,91L533,747.22l-13.38-28,144.93.42,0-.06c.78-2.81,25-89.28,41.27-100l0,0a7,7,0,0,1,1.79-.87s60.42-8,80.28-2.54c0,0,20.7,4.65,25.77,11l0,0c.68.71,8.52,9.54,10.95,35Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M836.91,731.87s-8.45,7.18-13.1,2.11c0,0-11.41-91.27-25.77-91.69l-49.44-.42s-5.91,2.53-8.45,13.52l-32,91L533,748.91l-13.38-28,144.93.42,0-.06c.78-2.81,25-89.28,41.27-100l0,0a7,7,0,0,1,1.79-.87s60.42-8,80.28-2.54c0,0,20.7,4.65,25.77,11l0,.05c.68.71,8.52,9.54,10.95,35Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M836.91,731.87s-8.45,7.18-13.1,2.11c0,0-11.41-91.27-25.77-91.69l-49.44-.42s-5.91,2.53-8.45,13.52l-32,91L533,748.91l-13.38-28,144.93.42,0-.06c.78-2.81,25-89.28,41.27-100l0,0a7,7,0,0,1,1.79-.87s60.42-8,80.28-2.54c0,0,20.7,4.65,25.77,11l0,.05c.68.71,8.52,9.54,10.95,35Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M729.59,632.15c-4.23,8-40.56,106.9-40.56,106.9L664.52,721.3l0-.06c.78-2.81,25-89.37,41.29-100C716.41,623,732.46,626.7,729.59,632.15Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M682.27,586.94,662.41,652l-103.52-3,.84,9.72s81.13,11.83,115.77-4.23l18.6-59.43,163.37.84-31.12-7.32Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M682.27,586.94,662.41,652l-103.52-3,.84,9.72s81.13,11.83,115.77-4.23l18.6-59.43,163.37.84-31.12-7.32Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#fff",
    opacity: 0.1
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M196.92,689.47s-55.49,27.89-14.37,54.09l11,2.53s-40.28-29,27-56.62Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M198.61,689.47s-55.49,27.89-14.37,54.09l11,2.53s-40.28-29,27-56.62Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#dce0ed"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 724.25,
    cy: 725.98,
    rx: 30.84,
    ry: 52.82,
    fill: "#636780"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 723.21,
    cy: 727.12,
    rx: 22.42,
    ry: 42.8,
    opacity: 0.1
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 723.21,
    cy: 725.43,
    rx: 22.42,
    ry: 42.8,
    fill: "#f0f0f4"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 727.28,
    cy: 696.71,
    rx: 2.65,
    ry: 5.28,
    fill: "#636780"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 737.88,
    cy: 742.93,
    rx: 2.65,
    ry: 5.28,
    fill: "#636780"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 709.3,
    cy: 720.92,
    rx: 2.65,
    ry: 5.28,
    fill: "#636780"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 717.06,
    cy: 751.73,
    rx: 2.65,
    ry: 5.28,
    fill: "#636780"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 741.66,
    cy: 714.32,
    rx: 2.65,
    ry: 5.28,
    fill: "#636780"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 727.28,
    cy: 727.08,
    rx: 7.76,
    ry: 12.54,
    fill: "#636780"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M324.8,524s93.81,3.38,215.49,36.76Z",
    transform: "translate(-48.43 -32.93)",
    opacity: 0.1
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M772.35,359.77s-5.09.82-2.44,7.54S773,377.5,773,377.5s5.1,2.65,4.89-6.12S772.35,359.77,772.35,359.77Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#dce0ed"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M522.84,496l-.06.08a9.54,9.54,0,0,0-2,4.61c-.82,5.34-1.6,16.28,6.17,14.47a24,24,0,0,0,11.58-6.29,9.49,9.49,0,0,0,2.57-7h0a7.3,7.3,0,0,0-3.21-6.1L535,494.11a5,5,0,0,0-2.7-.7l-5,.18A6.24,6.24,0,0,0,522.84,496Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#fec2be"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M579,404.5l-14.93,74.18L553.5,501l7,13L576,477.5s17-53.5,17-55S579,404.5,579,404.5Z",
    transform: "translate(-48.43 -32.93)",
    fill: "#01bf71"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg4);
export default __webpack_public_path__ + "static/media/svg-4.2882c3798c877234ee6cb7542aa7371a.svg";
export { ForwardRef as ReactComponent };